module.exports = __webpack_public_path__ + "1247f071a9a85976549c1fa64af31045.png";